/* Figma: Sidebar 2178:32738 — 212x1031, bg #130c42, padding 16, gap 8 */
.sidebar {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: var(--sidebar-w);
  min-height: 100%;
  padding: 16px;
  background: var(--bg-sidebar);
  border-right: 0.5px solid var(--border-sidebar);
}

.logo { width: 170px; height: 31px; flex-shrink: 0; }

.nav { display: flex; flex-direction: column; align-items: flex-start; width: 211px; }

/* Each top-level group is its own 12px-padded block (2178:32783 et al) */
.group {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  width: 100%;
  padding: 12px;
  background: var(--bg-sidebar);
}

.item {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  padding: 3px 6px;
  border-radius: var(--radius-chip);
  text-align: left;
}

.item.active { background: var(--bg-nav-active); }

.itemInner {
  display: flex;
  flex: 1 0 0;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
}

.itemLeft { display: flex; align-items: center; gap: 8px; }

.iconBox { display: flex; align-items: center; padding: 2px; }
.icon16 { width: 16px; height: 16px; flex-shrink: 0; }
.icon20 { width: 20px; height: 20px; flex-shrink: 0; }

.label {
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: var(--text-on-dark);
  letter-spacing: var(--letter-spacing);
  white-space: nowrap;
}

.chevron { width: 16px; height: 16px; flex-shrink: 0; transition: transform 140ms ease; }
.chevronOpen { transform: rotate(180deg); }

/* Children sit behind a 1px vertical rail (2178:32794 rotated Line 75) */
.children { display: flex; gap: 11px; align-items: flex-start; width: 100%; padding-left: 15px; }
.rail { width: 1px; align-self: stretch; background: rgba(255, 255, 255, 0.24); flex-shrink: 0; }
.childList { display: flex; flex: 1 0 0; flex-direction: column; gap: 8px; min-width: 0; }

/* Destinations outside this build read as unavailable rather than as buttons
   that silently do nothing. */
.item.disabled { opacity: 0.42; cursor: not-allowed; }
.item.disabled:hover { background: none; }
